(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-products-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-carousel')) {
    customElements.define(
      'bundle-carousel',
      class BundleCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.bundle-carousel__track');
          this.prev = this.querySelector('[name="previous"]');
          this.next = this.querySelector('[name="next"]');
          if (!this.track) return;
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          window.addEventListener('resize', () => this.update());
          if (this.prev) this.prev.addEventListener('click', () => this.scrollByPage(-1));
          if (this.next) this.next.addEventListener('click', () => this.scrollByPage(1));
          this.update();
        }
        scrollByPage(dir) {
          const slide = this.track.querySelector('.bundle-carousel__slide');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = slide ? slide.offsetWidth + gap : this.track.clientWidth / 2;
          this.track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
        }
        update() {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
